import { render } from "./GranularityToggle.vue?vue&type=template&id=1bca3e67&scoped=true"
import script from "./GranularityToggle.vue?vue&type=script&lang=js"
export * from "./GranularityToggle.vue?vue&type=script&lang=js"

import "./GranularityToggle.vue?vue&type=style&index=0&id=1bca3e67&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bca3e67"],['__file',"resources/js/components/GranularityToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bca3e67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bca3e67', __exports__)) {
    api.reload('1bca3e67', __exports__)
  }
  
  module.hot.accept("./GranularityToggle.vue?vue&type=template&id=1bca3e67&scoped=true", () => {
    api.rerender('1bca3e67', render)
  })

}


export default __exports__